import { LOGIN_PAGE_URL } from 'constants/utils';

import { Auth0ContextInterface, useAuth0, User } from '@auth0/auth0-react';
import {
  clearFilesSorts,
  deleteClientsListSize,
  deleteMobileInfoBannerClosed,
  getRefreshTokenFromLSAuth0,
  removeClientListScrollPosition,
  setAutoLogoutRedirectUrl
} from 'modules/networkTools/localStorageTokens';
import { logout } from 'modules/networkTools/networkTools';
import { useIdleTimer } from 'react-idle-timer';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch } from 'store/hooks';
import { deleteSearchQueryDraft } from 'store/myTodos/myTodosActions';

export const useAutoLogout = <T extends () => void>(idleTime: number, disabled: boolean) => {
  const dispatch = useAppDispatch();
  const { logout: auth0logout }: Auth0ContextInterface<User> = useAuth0();
  const [searchParams] = useSearchParams();

  const context = searchParams.get('context');
  const handleLogout = async () => {
    const lsRefreshToken = getRefreshTokenFromLSAuth0('auth0spajs');

    if (context === 'popup') {
      window.close();
      return;
    }
    localStorage.removeItem('lastPage');
    removeClientListScrollPosition();
    deleteClientsListSize();
    deleteMobileInfoBannerClosed();
    clearFilesSorts();
    if (lsRefreshToken) {
      await dispatch(deleteSearchQueryDraft());
      setAutoLogoutRedirectUrl(window.location.pathname);
      auth0logout({
        logoutParams: {
          returnTo: window.location.origin + LOGIN_PAGE_URL
        }
      });
      logout();
    }
  };

  useIdleTimer({
    timeout: idleTime * 60_000,
    onIdle: handleLogout,
    debounce: 0,
    crossTab: true,
    disabled,
    events: [
      'mousemove',
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mousewheel',
      'mousedown',
      'touchstart',
      'touchmove',
      'MSPointerDown',
      'MSPointerMove',
      'visibilitychange',
      'focus'
    ]
  });
};
